
import React from 'react';

interface DropdownHeaderProps {
  displayName?: string | null;
  username?: string | null;
  email?: string | null;
}

const getInitials = (value?: string | null) => {
  if (!value) return "U";
  const parts = value.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

const DropdownHeader = ({
  displayName,
  username,
  email,
}: DropdownHeaderProps) => {
  const name = displayName || username || email?.split("@")[0] || "User";
  const handle = username ? `@${username}` : email || "";

  return (
    <div className="flex items-center gap-2 px-2 py-2">
      <div className="h-8 w-8 rounded-full bg-orange-500 text-white flex items-center justify-center text-[11px] font-medium flex-shrink-0">
        {getInitials(name)}
      </div>
      <div className="min-w-0">
        <p className="text-sm font-medium text-gray-900 truncate">{name}</p>
        {handle && (
          <p className="text-xs text-gray-500 truncate">{handle}</p>
        )}
      </div>
    </div>
  );
};

export default DropdownHeader;
